import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { downloadFile } from 'ui-component/custom/FileMngr';
import { businessOpportunityActions } from './slice';
import capabilities from './capabilities';

export const ApiBusinessOpportunitiesGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post('workmgmt/businessopportunities/list', { filters, orderBy, groupBy, page, limit, includeSafeDeleted }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.setList(response?.data?.list));
                    dispatch(businessOpportunityActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesCountCollection = async ({
    filters = [],
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('workmgmt/businessopportunities/count', { filters, includeSafeDeleted }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiBusinessOpportunitiesPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post('workmgmt/businessopportunities', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post('workmgmt/businessopportunities/safedelete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(businessOpportunityActions.startExporting());
    }

    await gestopAPI
        .post(
            'workmgmt/businessopportunities/export',
            { exportType, format, columns, filters, orderBy, groupBy },
            { ...config, responseType: 'blob' }
        )
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(businessOpportunityActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(businessOpportunityActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .put(`workmgmt/businessopportunities/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .patch(`workmgmt/businessopportunities/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/businessopportunities/safedelete/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesRestoreDeletedItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/businessopportunities/restoresafedeleted/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesExportItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(businessOpportunityActions.startExporting());
    }

    await gestopAPI
        .get(`workmgmt/businessopportunities/export/${id}`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(businessOpportunityActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(businessOpportunityActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesApplyTransItem = async ({
    id,
    transition = '',
    data = {},
    successCallback,
    errorCallback,
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/businessopportunities/applytrans/${transition}/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesLockItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/businessopportunities/lock/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesUnlockItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/businessopportunities/unlock/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesArchiveItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/businessopportunities/archive/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityActions.startLoading());
    }

    await gestopAPI
        .get(`workmgmt/businessopportunities/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunitiesFileManagerIndex = async ({
    id,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/businessopportunities/filemanager/${id}?${params}`, data, {
            ...config,
            headers: { ...config?.headers } // Specific content type for file requests
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiBusinessOpportunitiesFileManagerUpload = async ({
    id,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/businessopportunities/filemanager/upload/${id}?${params}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' } // Specific content type for file requests
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiBusinessOpportunitiesFileManagerDownload = async ({
    id,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/businessopportunities/filemanager/download/${id}?${params}`, data, { ...config, responseType: 'blob' })
        .then((response) => {
            if (response.status === 200) {
                const contentType = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'names' in data ? data.names[0] : 'download';

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+)"/);
                    if (match) {
                        fileName = match[1];
                    }
                }

                downloadFile(response.data, fileName, contentType);

                if (typeof successCallback === 'function') {
                    successCallback(response.data);
                }
            } else if (typeof errorCallback === 'function') {
                errorCallback();
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};
